<template>
  <div>
    <div
      class="mt-2"
    >
      <b-switch
        v-model="basicProperties.hasInfoTooltip"
      >
        Show info tooltip
      </b-switch>
    </div>
    <div
      v-if="basicProperties.hasInfoTooltip"
      class="mt-2"
    >
      <Editor
        v-model="basicProperties.infoTooltipText"
        label="Info tooltip"
        :input="true"
      />
    </div>
  </div>
</template>

<script >
import { useBasicProperties } from '@/modules/builder/components/form-builder/properties/field-properties/basic-properties/basicProperties';
import Editor from '@/modules/core/components/wysiwyg/Editor';
const __sfc_main = {};
__sfc_main.props = {
  selectedFieldType: {
    type: String,
    default: 'field'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const {
    basicProperties
  } = useBasicProperties(props.selectedFieldType);
  return {
    basicProperties
  };
};
__sfc_main.components = Object.assign({
  Editor
}, __sfc_main.components);
export default __sfc_main;
</script>
